import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import {
  WizBasePopUp,
  WizButton,
  WizDatasource,
  WizDropdown,
  WizHgroup,
  WizLabel,
  WizTextInput,
  WizVgroup
} from '@wizeoo/akm-component-lib';
import { PivotField } from '../../../../../manager/baselines/pivot-field.obj';
import { StyleEngine } from '../../../../../manager/workingdata/style.engine';
import { ViewData } from '../../../../../model/view.data';
import { ColorPickerPop } from '../../../../colorpicker/color-picker.pop';
import { FakeVO } from '../../../../../vo/common/tool/fake.vo';
import { widgetHeaderVO } from './header-editext.pop';


@Component({
  // popUp d'édition des champs de pivot: style, label, méthode d'aggrégat
  selector: 'header-groupedit-pop',
  templateUrl: './header-groupedit.pop.html',
})
export class HeaderGroupEditPop extends WizBasePopUp {
  /** Zone de detail (pour updateEvent) */
  @ViewChild('vgDetailZone', { read: WizVgroup }) vgDetailZone: WizVgroup;
  @ViewChild('lbTitle', { read: WizLabel, static: false }) lbTitle: WizLabel; // titre de la popUp (fullcode)
 

  @ViewChild('gpHeader', { read: WizVgroup }) gpHeader: WizVgroup; // zone rendu du header (couleurs)
  @ViewChild('ddGrp', { read: WizDropdown }) ddGrp: WizDropdown; // drop de choix du groupe de colonne en mode grid
  @ViewChild('tiLabel', { read: WizTextInput, static: true }) tiLabel: WizTextInput; // ti de label
  @ViewChild('headerColors', { read: WizHgroup }) headerColors: WizHgroup; // groupe de la zone de dessin
  @ViewChild('blockFont') blockFont: ElementRef; // zone de dessin de la couleur de font
  @ViewChild('blockBack') blockBack: ElementRef; // zone de dessin de la couleur de background

  @ViewChild('ddHeaderAlign', { read: WizDropdown }) ddHeaderAlign: WizDropdown; // alignement des entêtes

  @ViewChild('btnSave', { read: WizButton, static: true }) btnSave: WizButton; // bt save

  /** DS des groupes parents possibles... */  
  public groupDS: WizDatasource<PivotField> = new WizDatasource<PivotField>([])
    .setSelectionMode('single')
    .setFilter(this.gpParentFilterFunc.bind(this))
    .build();

  /** DS alignement des entêtes */
  public headerAlignDS: WizDatasource<FakeVO> = new WizDatasource<FakeVO>([...ViewData.getInstance().textAlignList])
    .setSortFields([{ property: 'order', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();


  private doSaveFlag: boolean = true; // marqueur de validation des modifs (false sur cancel)

  public declare datas: widgetHeaderVO; // le contrat de données pour la pop

  public fontColor = StyleEngine.STYLE_DEFAULT_FONT_COLOR; // --grid-header-color
  public backgroundColor = StyleEngine.STYLE_DEFAULT_BACKGROUND_COLOR; // --grid-header-background-color
  public css: any = null;

  public static baseHeight: number = 260; // hauteur avec tout, statique pour prise externe sur ouverture
  public static baseWidth: number = 600; // largeur, statique pour prise externe sur ouverture


  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super();
  }

  public show(): void {
    super.show();

    setTimeout(() => {
      this.feed(); // alimentation des données et DS
      // this.manageVisibility();
    }, 0);
  }

  /** sur séquence de démarrage, alimentation des listes avec leurs DS */
  public feed(): void {
    
    this.lbTitle.wizLabel = this.datas.pivotField.fkd.code;
    this.tiLabel.setWizValue(this.datas.pivotField.labelOrDefaultLabel); // libellé du champ

    // gestion du rendu du header, alimentation font & background
    if (!!this.datas.pivotField.headerStyle) {
      const styleParts: string[] = this.datas.pivotField.headerStyle.split(ViewData.KEY_SEPARATOR);
      if (!!styleParts[0]) {
        this.backgroundColor = styleParts[0];
      }
      if (!!styleParts[1]) {
        this.fontColor = styleParts[1];
      }
    }
    // construction du CSS actif
    const parts: string[] = [];
    parts.push(StyleEngine.STYLE_FONT_COLOR + ViewData.KEY_PAIR_SEPARATOR + this.fontColor);
    parts.push(StyleEngine.STYLE_BACKGROUND_COLOR + ViewData.KEY_PAIR_SEPARATOR + this.backgroundColor);
    this.css = parts.join(ViewData.STYLE_ELEMENT_SEPARATOR);

    // gestion de l'alignement des headers
    let headerAlign: FakeVO = null; // le format de données
    let ha: string = this.datas.pivotField.headerAlign;
    headerAlign = this.headerAlignDS.getItemByKey(ha);
    this.headerAlignDS.select([headerAlign]);
    this.ddHeaderAlign.wizDataProvider = this.headerAlignDS;


    this.groupDS.setSource(this.datas.currentGroups); 
    let initPiv: PivotField = null;
    if (!!this.datas.pivotField.parentGroup) {
      this.groupDS.getSource().forEach((pf: PivotField) => {
        if (this.datas.pivotField.parentGroup === pf.fkd.code) {
          initPiv = pf;
        }
      });
    }
    this.groupDS.select([initPiv]);
    this.ddGrp.wizDataProvider = this.groupDS; 

  }


  /* ##############################################################################
                   sauvegarde
     ############################################################################## */

  /** Sauvegarde */
  public save(): void {
    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.doSaveFlag = false;
    this.hide();
  }

  /** sur hide, tentative d'enregistrement */
  public onHide() {
    if (this.doSaveFlag) {
     this.datas.pivotField.label = this.tiLabel.wizValue;
     this.datas.pivotField.headerStyle = this.backgroundColor + ViewData.KEY_SEPARATOR + this.fontColor;
     this.datas.pivotField.parentGroup = !!this.groupDS.selectedItem ? this.groupDS.selectedItem.fkd.code : null;
     this.datas.pivotField.headerAlign = !!this.headerAlignDS.selectedItem ? this.headerAlignDS.selectedItem.code : null;
     this.datas.updateCallback(this.datas.baseCollector, this.datas.pivotField);
    }
  }

  /* ##############################################################################
                   gestion du colorPicker pour la conf du header
     ############################################################################## */

  /**
   * affichage de la popUp du colorPicker
   * @param pEvent click
   */
  public showColorPicker(pEvent: Event): void {
    let targetColor = null;
    if (pEvent.target === this.blockFont.nativeElement) {
      targetColor = this.fontColor;
    } else if (pEvent.target === this.blockBack.nativeElement) {
      targetColor = this.backgroundColor;
    }
    pEvent.stopPropagation();
    pEvent.preventDefault();
    ColorPickerPop.show(this.blockFont.nativeElement, pEvent.target, targetColor, this.backFromPicker.bind(this));
  }

  /**
   * retour de colorPicker, alimentation des couleurs du header
   *
   * @param target le span source pour font ou background
   * @param color la couleur du picker
   */
  public backFromPicker(target: any, color: string): void {
    if (target === this.blockFont.nativeElement) {
      this.fontColor = color;
    } else if (target === this.blockBack.nativeElement) {
      this.backgroundColor = color;
    }
    this.feedHeaderStyle();
  }

  /** alimentation des slots de couleurs pour le header */
  public feedHeaderStyle(): void {
    const parts: string[] = [];
    parts.push(StyleEngine.STYLE_FONT_COLOR + ViewData.KEY_PAIR_SEPARATOR + this.fontColor);
    parts.push(StyleEngine.STYLE_BACKGROUND_COLOR + ViewData.KEY_PAIR_SEPARATOR + this.backgroundColor);

    this.css = parts.join(ViewData.STYLE_ELEMENT_SEPARATOR);
    this.cdref.markForCheck();
  }

  /** click sur les icones de suppression de style de header */
  public resetColor(who: string): void {
    if (who === 'blockFont') {
      this.fontColor = StyleEngine.STYLE_DEFAULT_FONT_COLOR; // --grid-header-color
    } else {
      // blockBack
      this.backgroundColor = StyleEngine.STYLE_DEFAULT_BACKGROUND_COLOR; // --grid-header-background-color
    }
    this.feedHeaderStyle();
  }

  /**
   * filter les parents possibles pour ne pas créer d'incohérences (pas moi, pas mes enfants)
   * @param item le groupe parent possible
   */
  public gpParentFilterFunc(item: PivotField): boolean {
    let result: boolean = true;
    if(item.fkd.code === this.datas.pivotField.fkd.code) {
      result = false;
      // console.log('self group', item.fkd.code);
    } else {
      if (item.parentGroup) { // seulement deux niveau, si j'ai un parent, c'est fini
        result = false;
        // console.log('has group', item);
      }
    }

    return result;
  }

}
